<script lang="ts" setup>
const props = defineProps<{
  data: any
}>()

const { t } = useI18n()

const years = [props?.data?.yearOfBirth, props?.data?.yearOfDeath].filter(Boolean)
const nationalities = props?.data?.nationalities?.map((n: any) => {
  const isPlaceOfBirthLabel = n.isPlaceOfBirth && props?.data?.nationalities?.length > 1 ? t('labels.placeOfBirth') : ''
  return [n.municipality, n.country].filter(Boolean).join(', ') + isPlaceOfBirthLabel
})
</script>

<template>
  <header>
    <h1 class="text-md">{{ data?.title }}</h1>

    <p
      class="text-md" 
      v-if="nationalities?.length === 1 && years?.length"
    >
      {{ nationalities[0] }}, {{ years.join('–') }}
    </p>

    <p
      class="text-md" 
      v-if="nationalities?.length > 1"
    >
      {{ nationalities.join('/') }}
    </p>

    <p 
      class="text-md "
      v-if="years?.length && (!nationalities?.length || nationalities?.length > 1)" 
    >
      {{ years.join('–')  }}
    </p>
  </header>
</template>